import { createAction } from '@ngrx/store';

export enum InitializeActionTypes {
	InitializeStart = '[App Initialize] Start',
	InitializeFinished = '[App Initialize] Finished',
}

/**
 * Tells the application we're starting the initialize phase
 */
export const initializeStart = createAction(InitializeActionTypes.InitializeStart);

/**
 * Tells the application we've finished the initialization phase
 */
export const initializeFinished = createAction(InitializeActionTypes.InitializeFinished);
